import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGhost: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGhost"><Path fillRule="evenodd" clipRule="evenodd" d="M12 2C7.58717 2 4 5.55142 4 9.94444V22.372L8.375 20.5617L12 22.0617L15.625 20.5617L20 22.372V9.94444C20 5.55142 16.4128 2 12 2ZM9.5 12C10.3284 12 11 11.3284 11 10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5C8 11.3284 8.67157 12 9.5 12ZM14.5 12C15.3284 12 16 11.3284 16 10.5C16 9.67157 15.3284 9 14.5 9C13.6716 9 13 9.67157 13 10.5C13 11.3284 13.6716 12 14.5 12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGhost;
